// extracted by mini-css-extract-plugin
export default {"root":"MSPlannerPage_root__78Xw5","contentFrame":"MSPlannerPage_contentFrame__Hn7qG","msLoginButton":"MSPlannerPage_msLoginButton__UROGo","msIcon":"MSPlannerPage_msIcon__HmfTU"};